import { render, staticRenderFns } from "./secure.vue?vue&type=template&id=58cb28ea&scoped=true&"
import script from "./secure.vue?vue&type=script&lang=js&"
export * from "./secure.vue?vue&type=script&lang=js&"
import style0 from "./secure.vue?vue&type=style&index=0&id=58cb28ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb28ea",
  null
  
)

export default component.exports